module.exports = __webpack_public_path__ + "img/menuTriangeWhite.42ddb54d.svg";